import { render, staticRenderFns } from "./ProposalDocumentsTab.vue?vue&type=template&id=1329bfcf&scoped=true"
import script from "./ProposalDocumentsTab.vue?vue&type=script&lang=js"
export * from "./ProposalDocumentsTab.vue?vue&type=script&lang=js"
import style0 from "./ProposalDocumentsTab.vue?vue&type=style&index=0&id=1329bfcf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1329bfcf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1329bfcf')) {
      api.createRecord('1329bfcf', component.options)
    } else {
      api.reload('1329bfcf', component.options)
    }
    module.hot.accept("./ProposalDocumentsTab.vue?vue&type=template&id=1329bfcf&scoped=true", function () {
      api.rerender('1329bfcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/tabs/ProposalDocumentsTab.vue"
export default component.exports